import { render, staticRenderFns } from "./product_add.vue?vue&type=template&id=17d7aa44&scoped=true&"
import script from "./product_add.vue?vue&type=script&lang=js&"
export * from "./product_add.vue?vue&type=script&lang=js&"
import style0 from "./product_add.vue?vue&type=style&index=0&id=17d7aa44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7aa44",
  null
  
)

export default component.exports